<dx-popup
  [width]="width"
  [height]="height"
  [showTitle]="showTitle()"
  [title]="title"
  [dragEnabled]="allowDrag"
  [resizeEnabled]="allowResize"
  [deferRendering]="false"
  [showCloseButton]="showCloseButton"
  [(visible)]="visible"
  (onHiding)="hiding()"
>
  <div *dxTemplate="let data of 'content'" class="image-editor-content">
    <dx-box
      [visible]="!webcamVisible"
      direction="col"
      height="100%"
      width="100%"
    >
      <dxi-item [ratio]="1" [visible]="disableAction">
        <div *dxTemplate>
          <dx-box direction="col" height="100%" width="100%">
            <dxi-item baseSize="auto" *ngIf="webcamAvailable && allowWebcam">
              <div *dxTemplate class="center-aligned">
                <dx-button
                  icon="photo"
                  (onClick)="showWebcam()"
                  hint="Camera"
                ></dx-button>
              </div>
            </dxi-item>
            <dxi-item [ratio]="1">
              <div *dxTemplate>
                <div
                  id="dropzone-external"
                  class="dx-theme-text-color-as-border-color dx-theme-border-color-as-background-color"
                >
                  <img
                    id="dropzone-image"
                    [src]="selectedImageFile"
                    *ngIf="selectedImageFile"
                    alt=""
                  />
                  <div class="flex-box">
                    <span>
                      Click
                      <a class="hyperlink">here</a>
                      or on Browse button to select file
                    </span>
                  </div>
                </div>
                <dx-file-uploader
                  #fileUploader
                  dialogTrigger="#dropzone-external"
                  [multiple]="false"
                  [accept]="allowedFileExtensionsString"
                  [allowedFileExtensions]="allowedFileExtensions"
                  uploadMode="instantly"
                  [visible]="false"
                  [(value)]="images"
                  (onValueChanged)="onImageFileSelected($event)"
                ></dx-file-uploader>
              </div>
            </dxi-item>
            <dxi-item baseSize="auto" *ngIf="isIOSDevice && allowWebcam">
              <dx-button
                class="camera-information-button"
                type="default"
                icon="info"
                hint="Camera Information"
                (onClick)="showWebcamInfo()"
              ></dx-button>
            </dxi-item>
          </dx-box>
        </div>
      </dxi-item>
      <dxi-item [ratio]="1" [visible]="!disableAction">
        <div *dxTemplate>
          <dx-box width="100%" height="100%" direction="col">
            <dxi-item baseSize="auto">
              <div *dxTemplate>
                <dx-toolbar>
                  <dxi-item
                    location="center"
                    widget="dxButton"
                    [options]="{
                      icon: 'revert',
                      hint: 'Rotate Left',
                      onClick: rotateLeft
                    }"
                  ></dxi-item>
                  <dxi-item
                    location="center"
                    widget="dxButton"
                    [options]="{
                      icon: 'redo',
                      hint: 'Rotate Right',
                      onClick: rotateRight
                    }"
                  ></dxi-item>
                  <dxi-item
                    location="center"
                    widget="dxButton"
                    [options]="{
                      icon: 'chevronnext',
                      hint: 'Flip Horizontal',
                      onClick: flipHorizontal
                    }"
                  ></dxi-item>
                  <dxi-item
                    location="center"
                    widget="dxButton"
                    [options]="{
                      icon: 'chevrondown',
                      hint: 'Flip Vertical',
                      onClick: flipVertical
                    }"
                  ></dxi-item>
                  <dxi-item
                    location="center"
                    widget="dxButton"
                    [options]="{
                      icon: 'clear',
                      hint: 'Clear Image',
                      onClick: clearImage
                    }"
                  ></dxi-item>
                </dx-toolbar>
              </div>
            </dxi-item>
            <dxi-item [ratio]="1">
              <div *dxTemplate>
                <div class="image-cropper-container">
                  <image-cropper
                    #ccImageCropper
                    class="image-cropper"
                    [imageChangedEvent]="imageChangedEvent"
                    [imageFile]="selectedImageFile"
                    [imageBase64]="selectedImageBase64"
                    [maintainAspectRatio]="true"
                    [aspectRatio]="1 / 1"
                    [resizeToWidth]="128"
                    [cropperMinWidth]="128"
                    [roundCropper]="true"
                    [autoCrop]="false"
                    format="png"
                    outputType="base64"
                    (imageCropped)="imageCropped($event)"
                    [transform]="transform"
                    (imageLoaded)="imageLoaded()"
                    (cropperReady)="cropperReady()"
                    (loadImageFailed)="loadImageFailed()"
                    [style.display]="showCropper ? null : 'none'"
                  ></image-cropper>
                </div>
              </div>
            </dxi-item>
          </dx-box>
        </div>
      </dxi-item>
      <dxi-item baseSize="auto">
        <dx-toolbar width="100%" class="toolbar-container">
          <dxi-item location="before">
            <div *dxTemplate>
              <dx-button
                type="default"
                [icon]="iconCancel"
                text="Cancel"
                hint="Cancel"
                (onClick)="hide()"
              ></dx-button>
            </div>
          </dxi-item>
          <dxi-item location="after">
            <div *dxTemplate>
              <dx-button
                type="default"
                text="Browse"
                hint="Browse"
                (onClick)="onImageBrowseClick()"
              ></dx-button>
            </div>
          </dxi-item>
          <dxi-item location="after">
            <div *dxTemplate>
              <dx-button
                type="success"
                text="Crop & Save"
                [icon]="iconSave"
                [disabled]="disableAction"
                (onClick)="onCropImageClick()"
              ></dx-button>
            </div>
          </dxi-item>
        </dx-toolbar>
      </dxi-item>
    </dx-box>
    <cc-web-cam
      [visible]="webcamVisible"
      (imageCaptured)="webcamImageCaptured($event)"
      (closed)="webcamClosed()"
    ></cc-web-cam>
  </div>
</dx-popup>

<dx-popup
  [width]="width"
  [height]="height"
  [showTitle]="true"
  title="Camera Information"
  [dragEnabled]="true"
  [resizeEnabled]="true"
  [showCloseButton]="true"
  [visible]="webcamInfoVisible"
>
  <dx-box width="100%" height="100%" direction="col">
    <dxi-item [ratio]="1">
      <div class="camera-information-items-center">
        <h4>Make sure to hold your device as shown in below image</h4>
        <img
          alt="Device orientation"
          src="assets/images/device-orientation.svg"
        />
      </div>
    </dxi-item>
    <dxi-item baseSize="auto">
      <div class="camera-information-items-center">
        <dx-button
          [width]="100"
          text="Ok"
          icon="fa-solid fa-check"
          type="default"
          (onClick)="closeWebcamInfo()"
        ></dx-button>
      </div>
    </dxi-item>
  </dx-box>
</dx-popup>
